import React, { memo } from 'react';
import {
  V1UsersiteBusinessesGetOneTypePayload,
  V1UsersiteFollowingBusinessesGetManyTypePayload,
} from '~/models/schema';
import AppContainer from '../../Container/AppContainer';
import T from 'i18n-react';
import Title from './components/Title';
import Item from './components/Item';
import Divider from '@material-ui/core/Divider';
import withStyles from '@material-ui/core/styles/withStyles';
import { BORDER_COLOR } from '../../../core/styles/variables';
import List from '@material-ui/core/List';
import Hidden from '@material-ui/core/Hidden';
import BusinessItem from './containers/BusinessItem';
import Button from './containers/Button';
import Introduction from '~/src/front/pages/FollowingBusinesses/components/Introduction';
import Pagination from '../../../core/Pagination';
import styled from 'styled-components';

const Border = withStyles((theme) => ({
  root: {
    backgroundColor: BORDER_COLOR,
    height: 2,
  },
}))(Divider);

const BusinessList = withStyles({
  root: {
    padding: 0,
    minHeight: 300,
  },
})(List);

const PaginationWrapper = styled.div`
  margin-top: 60px;
`;

type BusinessItemPayload = V1UsersiteBusinessesGetOneTypePayload & {
  business_site_id?: number | null;
  /** サーバーは camelCase でシリアライズするため両方受け付ける */
  businessSiteId?: number | null;
};

const Business = memo((props: BusinessItemPayload) => {
  const { id, name, displayName, introduction } = props;
  const businessName = displayName || name;
  const businessSiteId = props.businessSiteId ?? props.business_site_id;
  return (
    // @ts-ignore
    <Item alignItems="flex-start" divider>
      <BusinessItem {...props} name={businessName} />
      <Hidden xsDown>
        <Button id={id} name={businessName} businessSiteId={businessSiteId} />
      </Hidden>
      <Hidden smUp>
        {!!introduction && (
          <Introduction value={introduction} className="line-truncate-4" />
        )}
        <Button id={id} name={businessName} businessSiteId={businessSiteId} />
      </Hidden>
    </Item>
  );
});

interface Props extends V1UsersiteFollowingBusinessesGetManyTypePayload {
  count: number;
}

const FollowingBusinesses = ({ businesses, count }: Props) => {
  return (
    <AppContainer>
      <Title variant="h3">{T.translate('business.followListTitle')}</Title>
      <Border />
      <BusinessList>
        {businesses.map((props, index) => (
          <Business {...props} key={index} />
        ))}
      </BusinessList>
      {(count > 1 || businesses.length > 0) && (
        <PaginationWrapper>
          <Pagination count={count} />
        </PaginationWrapper>
      )}
    </AppContainer>
  );
};

export default FollowingBusinesses;
